import { LoaderData } from './GenericLoader';

export const spotLoader: LoaderData[] = [
  {
    type: 'tdflag',
    headerWidth: 0,
    width: 10,
    headerX: '0',
    x: '0',
  },
  {
    type: 'random_text',
    headerWidth: 150,
    width: 350,
    headerX: '10',
    x: '20',
  },
  { type: 'text', headerWidth: 40, width: 40, headerX: '62%', x: '62%' },
  {
    type: 'circle',
    headerWidth: 100,
    radius: 22,
    headerX: '70%',
    x: '75%',
  },
  {
    type: 'circle',
    headerWidth: 120,
    radius: 22,
    headerX: '80%',
    x: '85%',
  },
  {
    type: 'circle',
    radius: 17,
    headerWidth: 100,
    headerX: '92%',
    x: '95%',
  },
  {
    type: 'circle',
    radius: 17,
    headerWidth: 0,
    headerX: '90%',
    x: '98%',
  },
];
export const solicitacaoChamadaLoader: LoaderData[] = [
  {
    type: 'random_text',
    headerWidth: 100,
    width: 300,
    headerX: '0',
    x: '0',
  },
  { type: 'flag', headerWidth: 100, width: 150, headerX: '57%', x: '55%' },
  {
    type: 'circle',
    headerWidth: 150,
    radius: 22,
    headerX: '72%',
    x: '78%',
  },
  {
    type: 'circle',
    radius: 17,
    headerWidth: 150,
    headerX: '88%',
    x: '94%',
  },
];

export const chamadaEditLoader: LoaderData[] = [
  {
    type: 'random_text',
    headerWidth: 300,
    width: 300,
    headerX: '0',
    x: '0',
  },
  {
    type: 'random_text',
    headerWidth: 300,
    width: 300,
    headerX: '57%',
    x: '55%',
  },
];

export const solicitacaoPromoLoader: LoaderData[] = [
  {
    type: 'random_text',
    headerWidth: 100,
    width: 350,
    headerX: '0',
    x: '0',
  },
  { type: 'text', headerWidth: 100, width: 100, headerX: '40%', x: '40%' },
  { type: 'text', headerWidth: 100, width: 100, headerX: '50%', x: '50%' },
  {
    type: 'random_text',
    headerWidth: 120,
    width: 150,
    headerX: '60%',
    x: '60%',
  },
  {
    type: 'circle',
    headerWidth: 150,
    radius: 22,
    headerX: '74%',
    x: '80%',
  },
  {
    type: 'circle',
    radius: 17,
    headerWidth: 100,
    headerX: '92%',
    x: '95%',
  },
  {
    type: 'circle',
    radius: 17,
    headerWidth: 0,
    headerX: '90%',
    x: '98%',
  },
];
